// API Configuration
export const API_URL = process.env.REACT_APP_API_URL;
// "https://backend-empty-fire-4935.fly.dev" or "http://localhost:8000"

// Dispatch board base URL. Used to deep-link load cards by id, e.g.
// `${DISPATCH_BOARD_URL}/loads/<load_id>`.
export const DISPATCH_BOARD_URL =
  process.env.REACT_APP_DISPATCH_BOARD_URL || "http://localhost:5174";

// Other configuration constants can be added here as needed
export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
};

// Google Analytics
export const GA_TRACKING_ID = "G-Q1B8S91BLQ";

// Stripe — publishable key for the Book It carrier payment flow.
// CRA only exposes env vars prefixed with REACT_APP_ to the client bundle.
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
